import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {YzTreePickerComponent} from './yz-tree-picker/yz-tree-picker.component';
import {SharedModule} from "../shared.module";

const COMPONENTS = [
  YzTreePickerComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule],
  exports: [...COMPONENTS]
})
export class TreePickerModule {
}
